import React, { Component } from 'react'

import LinkedinButton from './linkedin-button'
import store from '../store'
import { TOGGLE_OPT_IN } from '../modules/positions'
import { ClipLoader } from 'react-spinners';

class OAuthLogin extends Component {

  state = {
    optIn: store.getState().positions.optIn,
  }

  _toggleOptIn = () => {
    this.setState({ optIn: !this.state.optIn })
    store.dispatch({type: TOGGLE_OPT_IN})
  }

  render() {
    const { loading } = this.props
    if (loading) {
      return (
        <div>
          <center>
            <ClipLoader
              sizeUnit={"px"}
              size={80}
              color={'#123abc'}
              loading={true}
            />
          </center>
        </div>
      )
    }
    const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77l0cafop1nzmd&redirect_uri=${window.location.href}&state=987654321&scope=r_liteprofile%20r_emailaddress`
    return (
      <div>
        <LinkedinButton url={url}/>
      </div>
    )
  }

}

export default OAuthLogin;



// WEBPACK FOOTER //
// ./src/components/login.js